import { ApttusDoOperationResponse } from '../../../common/models/apex-rest/doi-resubmission';

export class ChangeCartOwnerResponse extends ApttusDoOperationResponse {}
